import React from 'react'
import Translation from '../../General/Translation'
import GridItemSwitch from './GridItemSwitch'

const GridItems = ({
    items, 
    itemsData, 
    itemOnClick, 
    movieInformationOrder, 
    attributeStyling,
    theme, 
    stripeAppearance,
    activeItem, 
    onOpenPerformancePage,
    posterStyling, 
    isMobile,
    hiddenAttributes,
    hasGridHoverTrailer,
    dayFilters,
    isSlider = false,
    showPerformances = false,
    overviewFilterIgnoreOnPerformances,
    additionalScrollName, 
    isConnectedFast, 
    ignoreAttributesForPerformanceFilter,
    translation, 
    interscrollerId,
    interscrollerType,
    queryStringValues,
    interscrollerWeischerAds,
    interscrollerAdvertisements
}) => (
    0 === items.length ? (
        <h3 className="no-movie title-xlarge-theatre">
            <Translation id="ThereCurrentlyNoFilmsTypes" trans={translation}>Zurzeit laufen keine Filme dieser Art</Translation>
        </h3>
    ) : (
        items.map((itemId, index) => <GridItemSwitch
                key={itemId}
                itemId={itemId}
                index={index}
                dayFilters={dayFilters}
                theme={theme}    
                hiddenAttributes={hiddenAttributes}
                isSlider={isSlider}
                stripeAppearance={stripeAppearance}
                overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                itemsData={itemsData}
                isMobile={isMobile}
                showPerformances={showPerformances}
                queryStringValues={queryStringValues}
                onOpenPerformancePage={onOpenPerformancePage}
                itemOnClick={itemOnClick}
                movieInformationOrder={movieInformationOrder}
                attributeStyling={attributeStyling}
                hasGridHoverTrailer={hasGridHoverTrailer}
                activeItem={activeItem}
                posterStyling={posterStyling}
                additionalScrollName={additionalScrollName}
                isConnectedFast={isConnectedFast}
                translation={translation}
                interscrollerId={interscrollerId}
                interscrollerType={interscrollerType}
                interscrollerWeischerAds={interscrollerWeischerAds}
                interscrollerAdvertisements={interscrollerAdvertisements}
            />
        )
    )
)


export default GridItems